import React, { useState } from "react";
import "./App.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import phoneImage1 from "./assets/images/phone1.png";
import phoneImage2 from "./assets/images/phone2.png";
import phoneImage3 from "./assets/images/phone3.png";
import phoneImage4 from "./assets/images/phone4.png";
import phoneImage5 from "./assets/images/phone5.png";
import phoneImage6 from "./assets/images/phone6.png";
import phoneImage10 from "./assets/images/phone10.png";
import phoneImage11 from "./assets/images/phone11.png";
import phoneImage12 from "./assets/images/phone12.png";
import logo from "./assets/images/logo.png";
import appstore from "./assets/images/appstore.png";
import playstore from "./assets/images/playstore.png";
import constant from "./constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VideoModal from "./components/VideoModal";

function App() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportEmail, setReportEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [videoModal, setVideoModal] = useState(true);

  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${constant.baseUrl}/api/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        toast.success("Success! You've subscribed successfully!");
        setEmail("");
      } else {
        const { detail } = await response.json();
        toast.error(detail || "An error occurred. Please try again.");
      }
    } catch (error) {
      toast.error("Network error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleReportSubmit = async () => {
    if (!validateEmail(reportEmail)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!subject.trim() || !message.trim()) {
      toast.error("Subject and message cannot be empty.");
      return;
    }
    try {
      const response = await fetch(`${constant.baseUrl}/api/report`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: reportEmail,
          subject,
          message,
        }),
      });

      if (response.ok) {
        toast.success("Report submitted successfully!");
        setReportEmail("");
        setSubject("");
        setMessage("");
        setIsModalOpen(false);
      } else {
        const errorData = await response.json();
        toast.error(errorData.detail || "Failed to submit report.");
      }
    } catch (error) {
      toast.error("Network error. Please try again later.");
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  console.log("isModalOpen", isModalOpen);

  return (
    <div className="App">
      <img
        src={logo}
        alt="Mobile Logo"
        className="mobile-logo"
        style={{ marginTop: 24, marginLeft: 32 }}
      />

      <div className="button-container">
        <button className="report-button" onClick={() => setIsModalOpen(true)}>
          Report
        </button>

        <button className="report-button" onClick={() => setVideoModal(true)}>
          Intro
        </button>
        
      </div>

      {isModalOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2>Report Issue</h2>
            <div className="modal-input-container">
              <input
                type="email"
                placeholder="Your email"
                value={reportEmail}
                onChange={(e) => setReportEmail(e.target.value)}
              />
              <input
                type="text"
                placeholder="Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
              <textarea
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            <div className="modal-buttons">
              <button onClick={handleReportSubmit}>Submit</button>
              <button onClick={() => setIsModalOpen(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="header">
        <h1>
          Real-time communication & payment between landlords, vendors, and
          tenants
        </h1>
        <p>A.I. streamlines maintenance, blockchain secures leases</p>
      </div>

      <div className="animation-container">
        {/* Left iPhone with improved slider */}
        <div className="phone phone-left">
          <Swiper
            modules={[Autoplay, EffectFade]}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            effect="fade"
          >
            <SwiperSlide>
              <img
                src={phoneImage1}
                alt="Phone Screen 1"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage2}
                alt="Phone Screen 2"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage3}
                alt="Phone Screen 3"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage4}
                alt="Phone Screen 4"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage5}
                alt="Phone Screen 5"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage6}
                alt="Phone Screen 6"
                className="slider-image"
              />
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="logo-container hide-on-mobile">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "400px", height: "400px" }}
          />
        </div>

        <div className="phone phone-right">
          <Swiper
            modules={[Autoplay, EffectFade]}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            effect="fade"
          >
            <SwiperSlide>
              <img
                src={phoneImage10}
                alt="Phone Screen 10"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage11}
                alt="Phone Screen 11"
                className="slider-image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={phoneImage12}
                alt="Phone Screen 12"
                className="slider-image"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <div className="cta">
        <p>
          Join the waitlist now and experience the future of property
          management.
        </p>
        <div className="cta-input-container">
          <input
            type="email"
            className="cta-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "Submitting..." : "Get Notified"}
          </button>
        </div>
        <div className="store-buttons">
          <p>Available soon on:</p>
          <div className="stores">
            <a
              href="https://testflight.apple.com/join/TM1cmeSW"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appstore} alt="App Store" />
            </a>

            <a
              href="https://play.google.com/apps/testing/com.dwelio"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={playstore} alt="Google Play Store" />
            </a>
          </div>
        </div>
      </div>

      <footer>
        <p>Dwolio © 2024 - Revolutionizing Property Management</p>
      </footer>
      <VideoModal isOpen={videoModal} onClose={() => setVideoModal(false)} />
      <ToastContainer />
    </div>
  );
}

// Styles
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 8,
    minWidth: 300,
    maxWidth: "90%",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: 10,
    right: 10,
    fontSize: 20,
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
};

export default App;
